const API_URL = "https://www.dupaws.com/services/";

import JQuery from "jquery";
import store from "../data/store";
import auth from "../auth";

export default {
  getSitterProfile() {
    return $.ajax({
      type: "GET",
      url: API_URL + "api/initSitterData",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("SitterProfile", data);
      },
      error: function (data, status, error) {
        console.log(
          "Couldn't retrieve sitter through initSitterData() call: " +
            data.responseText
        );
      },
    });
  },

  updateSitterProfile() {
    return $.ajax({
      type: "POST",
      url: API_URL + "api/updateSitterData",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      crossDomain: true,
      data: JSON.stringify(store.getters.SitterProfile),
      contentType: "application/json",
      success: function (data) {},
      error: function (data, status, error) {
        console.log("failed to update SitterProfile " + data.responseText);
      },
    });
  },

  updateSitterPetPrefs() {
    return $.ajax({
      type: "POST",
      url: API_URL + "api/PetPref",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      crossDomain: true,
      data: JSON.stringify(store.getters.SitterPetPrefs),
      contentType: "application/json",
      success: function (data) {},
      error: function (data, status, error) {
        console.log("failed to update SitterProfile " + data.responseText);
      },
    });
  },

  getSitterPetPrefs() {
    return $.ajax({
      type: "GET",
      url: API_URL + "api/PetPref",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("SitterPetPrefs", data);
      },
      error: function (data, status, error) {
        console.log("failed to get Sitter Pet Prefs " + data.responseText);
      },
    });
  },
  getSitterServices() {
    return $.ajax({
      type: "GET",
      url: API_URL + "api/sitterServices",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("SitterServices", data);
      },
      error: function (data, status, error) {
        console.log("failed to get Sitter Services " + data.responseText);
      },
    });
  },
  getSitterProfileStatus() {
    return $.ajax({
      type: "GET",
      url: API_URL + "api/getSitterProfileStatus",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        //data is returned in calling functions.
      },
      error: function (data, status, error) {
        console.log("failed to get Sitter Profile Status" + data.responseText);
      },
    });
  },
  getSitterPhotos() {
    return $.ajax({
      type: "GET",
      url: API_URL + "api/getSitterPhotosList",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("SitterPhotos", data);
      },
      error: function (data, status, error) {
        console.log("failed to get Sitter Photos " + data.responseText);
      },
    });
  },
  updateSitterServices() {
    return $.ajax({
      type: "POST",
      url: API_URL + "api/sitterServices",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      crossDomain: true,
      data: JSON.stringify(store.getters.SitterServices),
      contentType: "application/json",
      success: function (data) {},
      error: function (data, status, error) {
        console.log("failed to update Sitter Services " + data.responseText);
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/sitterApi.js